import { render, staticRenderFns } from "./training.vue?vue&type=template&id=588ec787&scoped=true"
import script from "./training.vue?vue&type=script&lang=js"
export * from "./training.vue?vue&type=script&lang=js"
import style0 from "./training.vue?vue&type=style&index=0&id=588ec787&prod&scoped=true&lang=css"
import style1 from "./training.vue?vue&type=style&index=1&id=588ec787&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ec787",
  null
  
)

export default component.exports